import { render, staticRenderFns } from "./PaymentRejectedModal.vue?vue&type=template&id=058340a7&scoped=true&"
import script from "./PaymentRejectedModal.vue?vue&type=script&lang=js&"
export * from "./PaymentRejectedModal.vue?vue&type=script&lang=js&"
import style0 from "./PaymentRejectedModal.vue?vue&type=style&index=0&id=058340a7&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058340a7",
  null
  
)

export default component.exports